<div class="ibe-browser-warning" *ngIf="isBrowserIE">
    <span>
        <i class="ibe-icon ibe-icon-warning-circle"></i>
    </span>
    <span class="ibe-browser-warning-message" [innerHTML]="'guest_management.browser_warning' | translate"></span>
</div>

<router-outlet></router-outlet>
